import { useState, useEffect, useRef } from 'react'
import './PluginTipDia.css';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import {
    cppGetKugouAudioEffectStatus,
    cppSetKugouAudioEffectStatus,
    cppInstallAutoTunePlugin,
    cppInstallQQMusicAutoTunePlugin,
    cppInstallKwMusicPlugin,
    cppGetAppInfo,
    cppFixKugou,
} from '../../../api/cpp';
import { getKugouEffectTipDisable, setKugouEffectTipDisable } from '../../App/local';
import { compareVersions } from '../../../utils/index';
const appInfo = cppGetAppInfo();
const isNewVersion395 = compareVersions(appInfo && appInfo.version, "3.9.5"); //为true表示3.9.5以上新版本 不包含3.9.5本身
const isNewVersion396 = compareVersions(appInfo && appInfo.version, "3.9.6"); //为true表示3.9.6以上新版本 不包含3.9.6本身

const PluginTipDia = function(props) {
    const {
        playerData,
        sharpFlatState,
        vocalsPluginState,
        pluginTipDiaState,
        onClose
    } = props;
    
    const [isVisible, setIsVisible] = useState(pluginTipDiaState.isVisible);
    const [diaCloseKugouOpen, setDiaCloseKugouOpen] = useState(false);
    const [diaAddPluginOpen, setDiaAddPluginOpen] = useState(false);
    const timerRef = useRef(null);
    
    useEffect(() => {
        if (pluginTipDiaState.isVisible) {
            setIsVisible(true);
            // 5秒后自动隐藏
            timerRef.current = setTimeout(() => {
                setIsVisible(false);
                if (onClose) {
                    onClose();
                }
            }, 5000);
        } else {
            setIsVisible(false);
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        }
        
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, [pluginTipDiaState, onClose]);

    // 添加升降调插件
    const addSharpFlatPlugin = () => {
        if (playerData.player === "kugou") {
            cppInstallAutoTunePlugin("升降调", false);
            cppInstallAutoTunePlugin("emFix", false)
        } else if (playerData.player === "qq") {
            cppInstallQQMusicAutoTunePlugin("升降调");
        } else if (playerData.player === "kuwo") {
            cppInstallKwMusicPlugin("升降调");
        }
    }
    // 添加消人声插件
    const addVocalsPlugin = () => {
        if (playerData.player === "kugou") {
            cppInstallAutoTunePlugin("消人声", true);
            cppInstallAutoTunePlugin("emFix", false);
            // 3.9.5及以下的版本执行一次修复酷狗的命令
            if (!isNewVersion395) {
                cppFixKugou();
            }
        } else if (playerData.player === "qq") {
            cppInstallQQMusicAutoTunePlugin("消人声");
        } else if (playerData.player === "kuwo") {
            cppInstallKwMusicPlugin("消人声");
        }
    }

    const addPlugin = () => {
        setDiaAddPluginOpen(false)
        if (pluginTipDiaState.pluginName === "升降调") {
            addSharpFlatPlugin()
        } else if (pluginTipDiaState.pluginName === "消人声") {
            addVocalsPlugin()
        }
    }

    // 关闭酷狗音效
    const handleCloseKugouEffect = () => {
        setDiaCloseKugouOpen(false)
        cppSetKugouAudioEffectStatus(false);
    }
    // 禁用酷狗音效提示弹框
    const handleDisableKugouEffectTip = () => {
        setKugouEffectTipDisable(true);
        setIsVisible(false);
    }

    let pluginTipDiaEle = null;
    const isSupportPlayer = playerData.player === 'kugou' || playerData.player === 'qq' || playerData.player === 'kuwo';
    const kugouEffectEnable = cppGetKugouAudioEffectStatus();
    const sharpFlatOnline = sharpFlatState.online;
    const vocalsPlugOnline = vocalsPluginState.length > 0;
    const kugouEffectTipDisable = getKugouEffectTipDisable();
    
    if (pluginTipDiaState.pluginName === "升降调") {
        if (!sharpFlatOnline && isSupportPlayer) {
            pluginTipDiaEle = (
                <div className="PluginTipDia">
                    <div className="TipDialogContent">
                        <div className="TipText"><span className="RedColor">未识别</span>到升降调插件</div>
                    </div>
                    <div className="TipDialogAction Center">
                        <div className="YunBtn YellowColor" onClick={() => setDiaAddPluginOpen(true)}>添加插件</div>
                    </div>
                </div>
            )
        } else if (!sharpFlatOnline && !isSupportPlayer) {
            pluginTipDiaEle = (
                <div className="PluginTipDia">
                    <div className="TipDialogContent">
                        <div className="TipText"><span className="RedColor">未识别</span>到升降调插件</div>
                        <div className="TipText">您需要将升降调插件</div>
                        <div className="TipText"><span className="YellowColor">添加到机架</span>伴奏音轨</div>
                    </div>
                </div>
            )
        } else if (sharpFlatOnline && playerData.player === "kugou" && kugouEffectEnable && isNewVersion396 && !kugouEffectTipDisable) {
            pluginTipDiaEle = (
                <div className="PluginTipDia">
                    <div className="TipDialogContent">
                        <div className="TipText">因酷狗开启了音效</div>
                        <div className="TipText">升降调可能<span className="RedColor">不生效</span></div>
                    </div>
                    <div className="TipDialogAction">
                        <div className="YunBtn YellowColor" onClick={() => setDiaCloseKugouOpen(true)}>关闭音效</div>
                        <div className="YunBtn">取消提醒</div>
                    </div>
                </div>
            )
        }
    } else if (pluginTipDiaState.pluginName === "消人声") {
        if (!vocalsPlugOnline && isSupportPlayer) {
            pluginTipDiaEle = (
                <div className="PluginTipDia">
                    <div className="TipDialogContent">
                        <div className="TipText"><span className="RedColor">未识别</span>到消人声插件</div>
                    </div>
                    <div className="TipDialogAction Center">
                        <div className="YunBtn YellowColor" onClick={() => setDiaAddPluginOpen(true)}>添加插件</div>
                    </div>
                </div>
            )
        } else if (!vocalsPlugOnline && !isSupportPlayer) {
            pluginTipDiaEle = (
                <div className="PluginTipDia">
                    <div className="TipDialogContent">
                        <div className="TipText"><span className="RedColor">未识别</span>到消人声插件</div>
                        <div className="TipText">您需要将消人声插件</div>
                        <div className="TipText"><span className="YellowColor">添加到机架</span>伴奏音轨</div>
                    </div>
                </div>
            )
        } else if (vocalsPlugOnline && playerData.player === "kugou" && kugouEffectEnable && isNewVersion396 && !kugouEffectTipDisable) {
            pluginTipDiaEle = (
                <div className="PluginTipDia">
                    <div className="TipDialogContent">
                        <div className="TipText">因酷狗开启了音效</div>
                        <div className="TipText">消人声可能<span className="RedColor">不生效</span></div>
                    </div>
                    <div className="TipDialogAction">
                        <div className="YunBtn YellowColor" onClick={() => setDiaCloseKugouOpen(true)}>关闭音效</div>
                        <div className="YunBtn" onClick={handleDisableKugouEffectTip}>取消提醒</div>
                    </div>
                </div>
            )
        }
    }
    
    if (!isVisible && !diaCloseKugouOpen && !diaAddPluginOpen) {
        return null;
    }
    
    return (
        <div className="PluginTipDiaWrapper">
            {pluginTipDiaEle}
            <Dialog open={diaCloseKugouOpen} className="CloseKugouPluginTipDia">
                <DialogTitle>
                    提示
                </DialogTitle>
                <DialogContent>
                    关闭酷狗内部音效将会关闭您的酷狗播放器，是否继续？
                </DialogContent>
                <DialogActions>
                    <div className="YunBtn Small" onClick={() => setDiaCloseKugouOpen(false)}>取消</div>
                    <div className="YunBtn Small" onClick={handleCloseKugouEffect}>确认</div>
                </DialogActions>
            </Dialog>
            <Dialog open={diaAddPluginOpen} className="CloseKugouPluginTipDia">
                <DialogTitle>
                    提示
                </DialogTitle>
                <DialogContent>
                    添加插件将会关闭您的播放器，是否继续？
                </DialogContent>
                <DialogActions>
                    <div className="YunBtn Small" onClick={() => setDiaAddPluginOpen(false)}>取消</div>
                    <div className="YunBtn Small" onClick={addPlugin}>确认</div>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default PluginTipDia;
